import { Component, HostListener, Inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CertificationService } from './certifications/services/certification.service';
import { DOCUMENT } from '@angular/common';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})

export class AppComponent {

    title = 'ClientApp';
    websitecssUrl: any;

    constructor(
        public sanitizer: DomSanitizer,
        private certificationService: CertificationService,
        @Inject(DOCUMENT) private document: Document,
        private viewportScroller: ViewportScroller) {
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        if (document.body.scrollTop > 70 ||
            document.documentElement.scrollTop > 70) {
            document.body.classList.add('scrolled');
        }
        else {
            document.body.classList.remove('scrolled');
        }
    }

    public onClick(elementId: string): void {
        this.viewportScroller.scrollToAnchor(elementId);
    }

    ngOnInit() {

        this.certificationService.getAppStyleSheets()
            .subscribe((response: any) => {
                this.websitecssUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.websiteCss);
            });
    }

    onActivate(event) {
        window.scroll(0, 0);
    }
}
